import { render, staticRenderFns } from "./SubcontractorForm.vue?vue&type=template&id=5f522602"
import script from "./SubcontractorForm.vue?vue&type=script&lang=js"
export * from "./SubcontractorForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports